// extracted by css-extract-rspack-plugin
export default {"DashCardActionButtonsContainer":"gRnIz","DashCardActionsPanelContainer":"U4DIo","onLeftEdge":"MK4VK","isDashCardTabMenuOpen":"pfBpl"};